import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  background: white;
`;
export const HeroWrapper = styled.div`
  width: 100%;
  height: 652px;
  background-image: url("/nextasset/images/home/background.png");
  background-size: cover;
  @media (max-width: 900px) {
    background-image: none;
    background: #20b79d;
    height: 550px;
    border-radius: 0px 0px 50px 50px;
  }
  .hero {
    width: 100%;
    height: 652px;
    position: relative;
    padding-top: 100px;
    @media (max-width: 900px) {
      padding-top: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }
    ${(p) =>
      p.webConfig.dir === "ltr" &&
      `
            direction: rtl;
        `}
  }
  .search-title {
    display: block;
    color: white;
    font-size: 24px;
    font-weight: 700;
    width: 100%;
    @media (max-width: 900px) {
      font-size: 20px;
    }
    ${(p) =>
      p.webConfig.dir === "ltr" &&
      `
            text-align: left;
        `}
  }
  .column-flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 25px;
    width: 450px;
    @media (max-width: 900px) {
      width: 100%;
    }
  }
  .search-box {
    width: 100%;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    background: rgba(255, 255, 255, 0.3);
    padding: 22px;
    @media (max-width: 900px) {
      width: 100%;
    }
  }
  .row-flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 900px) {
      flex-direction: column;
      gap: 5px;
    }
  }
  .search-button {
    width: 100%;
    background: #201e67;
    font-size: 18px;
    font-weight: 700;
    height: 54px;
    @media (max-width: 900px) {
      height: 52px;
      font-size: 17px;
    }
  }
  .demo-req {
    padding: 15px 20px;
    background: white;
    box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    width: 80%;
    margin: auto;
    position: absolute;
    bottom: -20px;
    left: 12.5%;
    z-index: 1;
    ${(p) =>
      p.webConfig.dir === "ltr" &&
      `
            direction: ltr;
            @media (max-width: 433px) {
                width: 100% !important;
                bottom: 10px !important;
                left: 0 !important;
            }
            @media (max-width: 413px) {
                bottom: -30px !important;
            }
            @media (max-width: 334px) {
                bottom: -60px !important;
            }
            @media (max-width: 289px) {
                bottom: -100px !important;
            }
            @media (max-width: 254px) {
                bottom: -160px !important;
            }
            
        `}
    @media (max-width: 1300px) {
      bottom: 30px;
    }
    @media (max-width: 1100px) {
      width: 85%;
      left: 7.5%;
    }
    @media (max-width: 1000px) {
      bottom: 0px;
    }
    @media (max-width: 900px) {
      width: 95%;
      left: 2.5%;
      bottom: 10px;
      padding: 20px 10px;
    }
  }
  .demo-button {
    color: white;
    font-size: 16px;
    font-weight: 700;
    background: #201e67;
    padding: 19px 24px;
    border-radius: 8px;
    text-align: center;
    @media (max-width: 900px) {
      width: 100%;
      padding: 19px 10px;
      font-size: 14px;
    }
  }
  .demo-desc {
    color: #0d2439;
    font-size: 18px;
    font-weight: 700;
    line-height: 32px;
    width: 55%;
    @media (max-width: 900px) {
      width: 100%;
      margin-top: -5px;
      text-align: center;
      font-size: 14px;
    }
  }
`;

export const MobileAboutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f7;
  margin-top: 180px;
  @media (min-width: 1100px) {
    display: none;
  }

  .mobile-img {
    padding: 20px 16px;
  }
  .text {
    background: white;
    border-radius: 0 0 0 200px;
    padding: 20px 16px;
    padding-top: 0;
    padding-left: 40px;
    ${(p) =>
      p.webConfig.dir === "ltr" &&
      `
        border-radius: 0 0 200px 0;
        padding-right: 40px;
        padding-left: 16px;
    `}
  }
  .title {
    color: #201e68;
    font-size: 20px;
    font-weight: 700;
  }
  .desc {
    color: #0d2439;
    font-size: 15px;
    font-weight: 400;
    line-height: 32px;
    margin-top: 15px;
  }
`;

export const DesktopAboutWrapper = styled.div`
  width: 100%;
  height: auto;
  background: #f5f5f7;
  position: relative;
  padding-bottom: 70px;
  @media (max-width: 1100px) {
    display: none;
  }
  .text {
    position: absolute;
    top: 150px;
    right: 100px;
    width: 650px;
    @media (max-width: 1200px) {
      width: 550px;
      top: 120px;
    }
  }
  .title {
    color: #201e68;
    font-size: 32px;
    font-weight: 700;
  }
  .desc {
    color: #0d2439;
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
    margin-top: 25px;
    text-align: justify;
  }
  .desktop-items {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 1090px;
    gap: 20px;
    position: absolute;
    left: calc(50% - 545px);
    bottom: 50px;
  }
  .item {
    width: 350px;
    background: white;
    padding: 25px 32px;
    border-radius: 16px;
  }
  h3 {
    margin-top: -10px;
    text-align: center;
    color: #0d2439;
    font-size: 18px;
    font-weight: 700;
    line-height: 32px;
  }
  h4 {
    margin-bottom: -5px;
    margin-top: -5px;
    text-align: center;
    color: #0d2439;
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
  }
`;

export const ServicesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 80px;
  margin-top: 100px;
  @media (max-width: 600px) {
    margin-top: 80px;
    gap: 60px;
  }
  .title {
    color: #0d2439;
    font-size: 32px;
    font-weight: 700;
    text-align: center;
    margin-bottom: -30px;
    @media (max-width: 600px) {
      font-size: 20px;
    }
  }
`;

export const FooterWrapper = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  .img {
    object-fit: cover;
  }
  .column-flex {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    position: absolute;
    height: 280px;
    top: calc(50% - 165px);
    left: 200px;
    @media (max-width: 1100px) {
      gap: 15px;
    }
    @media (max-width: 900px) {
      gap: 40px;
      left: 100px;
    }
    @media (max-width: 600px) {
      gap: 15px;
      left: 50px;
    }
    @media (max-width: 400px) {
      gap: 5px;
    }
  }
  .title {
    color: #0d2439;
    font-size: 32px;
    font-weight: 700;
    @media (max-width: 1100px) {
      font-size: 20px;
    }
    @media (max-width: 900px) {
      font-size: 32px;
    }
    @media (max-width: 600px) {
      font-size: 20px;
    }
    @media (max-width: 400px) {
      font-size: 17px;
    }
  }
  .desc {
    color: #0d2439;
    font-size: 20px;
    font-weight: 700;
    @media (max-width: 1100px) {
      font-size: 14px;
    }
    @media (max-width: 900px) {
      font-size: 20px;
    }
    @media (max-width: 600px) {
      font-size: 14px;
    }
    @media (max-width: 400px) {
      font-size: 12px;
    }
  }
  .link {
    color: white;
    font-size: 16px;
    font-weight: 700;
    background: #201e67;
    box-shadow: 0px 0px 0px 8px #dedde9;
    border-radius: 8px;
    width: 100%;
    height: 52px;
    text-align: center;
    line-height: 52px;
    @media (max-width: 1100px) {
      font-size: 14px;
      height: 48px;
      line-height: 48px;
    }
    @media (max-width: 900px) {
      font-size: 16px;
      height: 52px;
      line-height: 52px;
    }
    @media (max-width: 600px) {
      font-size: 14px;
      height: 48px;
      line-height: 48px;
    }
    @media (max-width: 400px) {
      font-size: 12px;
      height: 46px;
      line-height: 46px;
    }
  }
`;

export const BlogWrapper = styled.div`
  width: 100%;
  background: #f5f5f7;
  padding: 60px 0;
  margin-top: 100px;
  @media (max-width: 600px) {
    padding: 40px 0;
  }
  .row-flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .blog-posts {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 25px;
    @media (max-width: 1440px) {
      display: none;
    }
  }
  .carousel {
    width: 100%;
    @media (min-width: 1441px) {
      display: none;
    }
  }
  .wrapper {
    width: 74%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    @media (max-width: 1200px) {
      width: 82%;
    }
    @media (max-width: 900px) {
      width: 100%;
    }
  }
  .link {
    color: #201e68;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    @media (max-width: 600px) {
      font-size: 15px;
    }
    .icon {
      width: 17px;
      height: 17px;
      color: #201e68;
      @media (max-width: 600px) {
        width: 16px;
        height: 16px;
      }
    }
  }
`;

export const PostWrapper = styled.div`
  width: 280px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 16px;
  background: white;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
  height: auto;
  .banner {
    border-radius: 16px 16px 0 0;
  }
  .title {
    color: black;
    font-size: 16px;
    font-weight: 700;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    padding: 0 16px;
    margin-top: -0.5px;
    @media (max-width: 600px) {
      font-size: 15px;
    }
  }
  .subtitle {
    padding: 0 16px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    color: #0d2439;
    font-size: 14px;
    line-height: 28px;
    margin-top: -10px;
    @media (max-width: 600px) {
      font-size: 13px;
    }
  }
`;

export const CollaborateWrapper = styled.div`
  width: 100%;
  padding: 100px 0;
  @media (max-width: 600px) {
    padding: 80px 0;
  }
  .collaborates {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 25px;
    @media (max-width: 1440px) {
      display: none;
    }
  }
  .carousel {
    width: 100%;
    @media (min-width: 1441px) {
      display: none;
    }
  }
  .wrapper {
    width: 74%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    @media (max-width: 1200px) {
      width: 82%;
    }
    @media (max-width: 900px) {
      width: 100%;
    }
  }
  .title {
    color: #201e68;
    font-size: 32px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
    @media (max-width: 600px) {
      font-size: 20px;
    }
  }
`;

export const CollaborateItemWrapper = styled.div`
  width: 280px;
  border-radius: 16px;
  background: white;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
  .collaborate-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0 20px;
    height: 370px;
  }
  .icon {
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .icon1 {
    position: absolute;
    bottom: 20px;
    left: 20px;
  }
  .arrow {
    position: absolute;
    bottom: -8px;
    right: calc(50% - 51.5px);
  }
  .img {
    border-radius: 50%;
  }
  .title {
    color: #201e68;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    @media (max-width: 600px) {
      font-size: 15px;
    }
  }
  .subtitle {
    color: #201e68;
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    margin-top: -20px;
    @media (max-width: 600px) {
      font-size: 14px;
    }
  }
`;
